import { Byte } from '../../enums';
var UploadConfig = /** @class */ (function () {
    function UploadConfig(maximum) {
        this.endpoint = '/upload';
        this.minSize = 0;
        this.size = 3 * Byte.MEGA; // 3MB
        this.timeout = 0;
        this.maximum = 0;
        this.multiple = true;
        this.directory = false;
        this.drop = true;
        this.dropDirectory = true;
        this.addIndex = false;
        this.thread = 1;
        this.data = {};
        this.headers = {};
        if (maximum && maximum > 0) {
            this.maximum = maximum;
            this.multiple = false;
        }
    }
    UploadConfig.compressedImageStandard = {
        convertSize: 0,
        width: 1280,
        height: 720,
        quality: 0.8,
    };
    UploadConfig.compressedImageAvatar = {
        convertSize: 0,
        width: 720,
        height: 720,
        quality: 0.8,
    };
    UploadConfig.compressedImageThumb = {
        convertSize: 0,
        width: 320,
        height: 180,
        quality: 0.7,
    };
    return UploadConfig;
}());
export { UploadConfig };
//# sourceMappingURL=UploadConfig.js.map